// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-C":"C_solar-60w-C__1PKgN"};